import React, { useEffect } from 'react';
import { IVenueSelect } from './types';
import style from './style.module.scss';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/main/rootReducer';
import { headers } from '../../_helpers/requestHeaders';

const NS = 'VenueSelect';

// If you need theme-based styles, create them here, otherwise add them to 'style.module.scss'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  venueName: {
    marginRight: theme.spacing(1),
  }
}));

export default function VenueSelect({handleSomeClick, handleVenueListDrawerOpen}: IVenueSelect) {
  const classes = useStyles();
  const { selectedVenue, openVenueListDrawer } = useSelector((state: RootState) => state.venueReducer);

  return (
    <div className={classes.root}>
      <Typography variant="subtitle2" data-testid="venue-name" noWrap className={classes.venueName}>Your venue: {selectedVenue.name}</Typography>
      <Typography variant="caption" noWrap>(version: {headers.appVersion}) &nbsp;&nbsp;&nbsp;</Typography>
      <Link
        data-testid="venue-list-button"
        component="button"
        variant="body2"
        color="inherit"
        onClick={() => {
          if (!openVenueListDrawer)
            handleVenueListDrawerOpen();
        }}
      >
        Change
      </Link>
    </div>
  )
}
